import React from 'react';
import { useMediaProtection } from '../hooks/useMediaProtection';

const MediaProtection: React.FC = () => {
  useMediaProtection();
  return null;
};

export default MediaProtection;

